import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-cronometrojubot',
  templateUrl: './cronometrojubot.component.html',
  styleUrls: ['./cronometrojubot.component.css']
})
export class CronometrojubotComponent implements OnInit {

  public minutos: number = 3;
  public minutosstring = "3";
  public segundos: number = 60;
  public color: string = "#0FD332";

  constructor(@Inject(DOCUMENT) document) { }

  ngOnInit() {
   

   

  //  this.start();
    
  }


  limpiasegundos(){
    for (let i = 0; i < 60; i++) {
      var svg_css = document.getElementById("segbotjm" + i );
        svg_css.style.fill= "#ffffff";
    }
  }

  start(){
    setInterval( ()=>{
        this.segundos = this.segundos - 1;
        var svg_css = document.getElementById("segbotjm" + this.segundos );
        svg_css.style.fill= this.color;
        console.log (this.segundos);
        if ( this.segundos == 1 ){
          this.segundos = 60;
          this.minutos = this.minutos - 1;
          if (this.minutos == 2) {
            this.color = '#F38604';
          }

          if (this.minutos == 1) {
            this.color = '#EA0000';
          }

          if (this.minutos == 0) {
            this.color = '#EA0000';
          }

          this.minutosstring = String(this.minutos);

          var svg_innerHTML = document.getElementById("textminutos");
          svg_innerHTML.innerHTML= this.minutosstring;
        
        }

    }, 1000);
  }
  

}
